import React, {Fragment} from "react";
import {Button, Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {
  getFormFieldValue,
  setFormFieldValue,
  traversePropertiesArray,
  traversePropertiesString
} from '../shared/shared';
import {Beneficiary} from "../components/Beneficiary";
import {InputAdapter, TextMask} from "react-text-mask-hoc";

export function BeneficiaryInfo(props) {
  const {values, handleCB, readonly, token, formFields} = props;

  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h4>{getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" ? "Primary " : ""}Beneficiary
            Information</h4>
        </Col>
      </Row>
      {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && (
        <Row>
          <Col xs={"2"}>
            <FormGroup check className="form-check-inline">
              <Label check htmlFor="useSpouse">
                <Input type="checkbox" id="useSpouse"
                       name="useSpouse" value="1"
                       checked={getFormFieldValue(values.useSpouse) == 0 ? false : true}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.checked ? 1 : 0, values, readonly, handleCB)}/>
                Use Spouse
              </Label>
            </FormGroup>
          </Col>
          {getFormFieldValue(values.useSpouse) == 1 && (
            <Col xs={"4"}>
              <FormGroup>
                <Label htmlFor="spouseShare">Share %</Label>
                <TextMask
                  mask={[/[0-9]/, /[0-9]/, /[0-9]/]}
                  Component={InputAdapter}
                  className="form-control"
                  guide={false}
                  showMask={false}
                  id="spouseShare"
                  value={getFormFieldValue(values.spouseShare)}
                  onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
                />
                <FormText color="muted">
                  % (If all blank, equally distributed)
                </FormText>
              </FormGroup>
            </Col>
          )}
        </Row>
      )}

      {traversePropertiesArray(values, ['beneficiary']).map(function (beneficiary, index) {
        return (
          <Row key={index} style={{backgroundColor: "#dfdfdf", marginTop: 2}}>
            <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "right"}}>
              <FormGroup>
                <Button color="danger"
                        onClick={(evt) => removeArray('beneficiary', index)}>Remove</Button>
                <br/><br/>
                <Label htmlFor="useAddress">Mailing&nbsp;Address*</Label>
                <Input type="select" name="useAddress" id="useAddress"
                       value={getFormFieldValue(beneficiary.useAddress)}
                       onChange={(evt) => setArrayValues(index, "beneficiary", {
                         ...beneficiary,
                         [evt.target.id]: evt.target.value
                       }, beneficiary || {}, readonly, handleCB)}>
                  <option key={0} value={""}>New</option>
                  <option key={1} value={"primary"}>Use Primary</option>
                  {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && getFormFieldValue(traversePropertiesString(formFields, ['spouse', 'currentUseNew'])) === "1" && (
                    <option key={2} value={"spouse"}>Use Spouse</option>
                  )}
                </Input>
              </FormGroup>
            </Col>
            <Col xs={8}>
              <Beneficiary values={beneficiary || {}}
                           handleCB={(field, value) => setArrayValues(index, "beneficiary", field, beneficiary || {}, readonly, handleCB)}
                           readonly={readonly} formFields={formFields} token={token}/>
            </Col>
            {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && (
              <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "left"}}>
                <Button color="info"
                        onClick={(evt) => copyArray('beneficiary', 'spouseBeneficiary', index)}>Copy To Spouse</Button>
              </Col>
            )}
          </Row>
        )
      })}
      <Row>
        <Col xs={"1"}/>
        <Col xs={"2"}>
          <Button color="primary"
                  onClick={(evt) => addArray('beneficiary')}>{traversePropertiesArray(values, ['beneficiary']).length === 0 ? "Add" : "Add Row"}</Button>
        </Col>
      </Row>

      <br/>

      <Row>
        <Col xs="1" />
        <Col xs={"11"}>
          <h5>{getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" ? "Primary " : ""}
            Contingencies</h5>
        </Col>
      </Row>

      {traversePropertiesArray(values, ['beneficiaryContingency']).map(function (beneficiaryContingency, index) {
        return (
          <Row key={index} style={{backgroundColor: "#dfdfdf", marginTop: 2}}>
            <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "right"}}>
              <FormGroup>
                <Button color="danger"
                        onClick={(evt) => removeArray('beneficiaryContingency', index)}>Remove</Button>
                <br/><br/>
                <Label htmlFor="useAddress">Mailing&nbsp;Address*</Label>
                <Input type="select" name="useAddress" id="useAddress"
                       value={getFormFieldValue(beneficiaryContingency.useAddress)}
                       onChange={(evt) => setArrayValues(index, "beneficiaryContingency", {
                         ...beneficiaryContingency,
                         [evt.target.id]: evt.target.value
                       }, beneficiaryContingency || {}, readonly, handleCB)}>
                  <option key={0} value={""}>New</option>
                  <option key={1} value={"primary"}>Use Primary</option>
                  {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && getFormFieldValue(traversePropertiesString(formFields, ['spouse', 'currentUseNew'])) === "1" && (
                    <option key={2} value={"spouse"}>Use Spouse</option>
                  )}
                </Input>
              </FormGroup>
            </Col>
            <Col xs={8}>
              <Beneficiary values={beneficiaryContingency || {}}
                           handleCB={(field, value) => setArrayValues(index, "beneficiaryContingency", field, beneficiaryContingency || {}, readonly, handleCB)}
                           readonly={readonly} formFields={formFields} token={token}/>
            </Col>
            {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && (
              <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "left"}}>
                <Button color="info"
                        onClick={(evt) => copyArray('beneficiaryContingency', 'spouseBeneficiaryContingency', index)}>Copy To Spouse</Button>
              </Col>
            )}
          </Row>
        )
      })}
      <Row>
        <Col xs={"1"}/>
        <Col xs={"2"}>
          <Button color="primary"
                  onClick={(evt) => addArray('beneficiaryContingency')}>{traversePropertiesArray(values, ['beneficiaryContingency']).length === 0 ? "Add" : "Add Row"}</Button>
        </Col>
      </Row>

      <br/>

      {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && (
        <Fragment>
          <Row>
            <Col xs={"12"}>
              <h4>Spouse Beneficiary Information</h4>
            </Col>
          </Row>

          <Row>
            <Col xs={"2"}>
              <FormGroup check className="form-check-inline">
                <Label check htmlFor="usePrimary">
                  <Input type="checkbox" id="usePrimary"
                         name="usePrimary" value="1"
                         checked={getFormFieldValue(values.usePrimary) == 0 ? false : true}
                         onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.checked ? 1 : 0, values, readonly, handleCB)}/>
                  Use Primary
                </Label>
              </FormGroup>
            </Col>
            {getFormFieldValue(values.usePrimary) == 1 && (
              <Col xs={"4"}>
                <FormGroup>
                  <Label htmlFor="primaryShare">Share %</Label>
                  <TextMask
                    mask={[/[0-9]/, /[0-9]/, /[0-9]/]}
                    Component={InputAdapter}
                    className="form-control"
                    guide={false}
                    showMask={false}
                    id="primaryShare"
                    value={getFormFieldValue(values.primaryShare)}
                    onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
                  />
                  <FormText color="muted">
                    % (If all blank, equally distributed)
                  </FormText>
                </FormGroup>
              </Col>
            )}
          </Row>

          {traversePropertiesArray(values, ['spouseBeneficiary']).map(function (beneficiary, index) {
            return (
              <Row key={index} style={{backgroundColor: "#dfdfdf", marginTop: 2}}>
                <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "right"}}>
                  <FormGroup>
                    <Button color="danger"
                            onClick={(evt) => removeArray('spouseBeneficiary', index)}>Remove</Button>
                    <br/><br/>
                    <Label htmlFor="useAddress">Mailing&nbsp;Address*</Label>
                    <Input type="select" name="useAddress" id="useAddress"
                           value={getFormFieldValue(beneficiary.useAddress)}
                           onChange={(evt) => setArrayValues(index, "spouseBeneficiary", {
                             ...beneficiary,
                             [evt.target.id]: evt.target.value
                           }, beneficiary || {}, readonly, handleCB)}>
                      <option key={0} value={""}>New</option>
                      <option key={1} value={"primary"}>Use Primary</option>
                      {getFormFieldValue(traversePropertiesString(formFields, ['spouse', 'currentUseNew'])) === "1" && (
                        <option key={2} value={"spouse"}>Use Spouse</option>
                      )}
                    </Input>
                  </FormGroup>
                </Col>
                <Col xs={8}>
                  <Beneficiary values={beneficiary || {}}
                               handleCB={(field, value) => setArrayValues(index, "spouseBeneficiary", field, beneficiary || {}, readonly, handleCB)}
                               readonly={readonly} formFields={formFields} token={token}/>
                </Col>
                <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "left"}}>
                  <Button color="info"
                          onClick={(evt) => copyArray( 'spouseBeneficiary','beneficiary', index)}>Copy To Primary</Button>
                </Col>
              </Row>
            )
          })}
          <Row>
            <Col xs={"1"}/>
            <Col xs={"2"}>
              <Button color="primary"
                      onClick={(evt) => addArray('spouseBeneficiary')}>{traversePropertiesArray(values, ['spouseBeneficiary']).length === 0 ? "Add" : "Add Row"}</Button>
            </Col>
          </Row>

          <br/>

          <Row>
            <Col xs="1" />
            <Col xs={"11"}>
              <h5>Spouse Contingencies</h5>
            </Col>
          </Row>

          {traversePropertiesArray(values, ['spouseBeneficiaryContingency']).map(function (spouseBeneficiaryContingency, index) {
            return (
              <Row key={index} style={{backgroundColor: "#dfdfdf", marginTop: 2}}>
                <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "right"}}>
                  <FormGroup>
                    <Button color="danger"
                            onClick={(evt) => removeArray('spouseBeneficiaryContingency', index)}>Remove</Button>
                    <br/><br/>
                    <Label htmlFor="useAddress">Mailing&nbsp;Address*</Label>
                    <Input type="select" name="useAddress" id="useAddress"
                           value={getFormFieldValue(spouseBeneficiaryContingency.useAddress)}
                           onChange={(evt) => setArrayValues(index, "spouseBeneficiaryContingency", {
                             ...spouseBeneficiaryContingency,
                             [evt.target.id]: evt.target.value
                           }, spouseBeneficiaryContingency || {}, readonly, handleCB)}>
                      <option key={0} value={""}>New</option>
                      <option key={1} value={"primary"}>Use Primary</option>
                      {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && getFormFieldValue(traversePropertiesString(formFields, ['spouse', 'currentUseNew'])) === "1" && (
                        <option key={2} value={"spouse"}>Use Spouse</option>
                      )}
                    </Input>
                  </FormGroup>
                </Col>
                <Col xs={8}>
                  <Beneficiary values={spouseBeneficiaryContingency || {}}
                               handleCB={(field, value) => setArrayValues(index, "spouseBeneficiaryContingency", field, spouseBeneficiaryContingency || {}, readonly, handleCB)}
                               readonly={readonly} formFields={formFields} token={token}/>
                </Col>
                {getFormFieldValue(traversePropertiesString(formFields, ['basic', 'relationshipStatus'])) === "M" && (
                  <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "left"}}>
                    <Button color="info"
                            onClick={(evt) => copyArray('spouseBeneficiaryContingency', 'beneficiaryContingency', index)}>Copy To Primary</Button>
                  </Col>
                )}
              </Row>
            )
          })}
          <Row>
            <Col xs={"1"}/>
            <Col xs={"2"}>
              <Button color="primary"
                      onClick={(evt) => addArray('spouseBeneficiaryContingency')}>{traversePropertiesArray(values, ['spouseBeneficiaryContingency']).length === 0 ? "Add" : "Add Row"}</Button>
            </Col>
          </Row>

        </Fragment>
      )}
    </Fragment>
  );

  function setArrayValues(index, field, value, medicineObj, readonly1, handleCB1) {
    const newValues = traversePropertiesArray(values, [field]);
    newValues[index] = value;
    setFormFieldValue(field, newValues, values, readonly, handleCB);
  }

  function addArray(type) {
    const newValues = traversePropertiesArray(values, [type]);
    newValues.push({});
    values[type] = newValues;
    handleCB(values);
  }

  function removeArray(type, index) {
    const newValues = traversePropertiesArray(values, [type]);
    newValues.splice(index, 1);
    values[type] = newValues;
    handleCB(values);
  }

  function copyArray(fromType, toType, index) {
    const fromValue = traversePropertiesArray(values, [fromType], index)[0];
    const toValues = traversePropertiesArray(values, [toType]);
    toValues.push(fromValue);
    values[toType] = toValues;
    handleCB(values);
  }
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/BeneficiaryInfo.js